import { type PartnerResItem, RecordOrigin } from '@sr/types';

import { getPartnerRecordOrigin } from './partnerAxis';

type PartnerDisplayInput = {
  source: string;
  customerText?: string;
  additionalDescription?: string;
  description?: string;
  name: string;
  street?: string;
  parentId?: string | number | null;
  childCount?: number;
};

const withoutPlaceholder = (value?: string) => (value ? value.replace('N/A', '') : '');

export const getIsPartnerActive = (
  partner: Pick<PartnerResItem, 'countryId' | 'isActive' | 'isActivePickupPlace'>,
) => {
  if (partner.countryId === 'SE') {
    return partner.isActive;
  }

  return partner.isActivePickupPlace;
};

/**
 * The name, description and address a Partner is shown under. Datalake-shaped records
 * carry their label in `description` and their own `name`; warehouse records fall back to
 * the customer text.
 */
export const getPartnerDisplayFields = (res: PartnerDisplayInput) => {
  const fallbackDescription =
    withoutPlaceholder(res.customerText) || withoutPlaceholder(res.additionalDescription);

  if (getPartnerRecordOrigin(res) !== RecordOrigin.EDW) {
    return {
      name: res.name,
      description: res.description || fallbackDescription,
      street: withoutPlaceholder(res.street),
      isPartHierarchy: Boolean(res.parentId) || Boolean(res.childCount && res.childCount > 0),
    };
  }

  return {
    name: res.description ? res.description : res.name,
    description: fallbackDescription,
    street: withoutPlaceholder(res.street),
    isPartHierarchy: Boolean(res.parentId) || Boolean(res.childCount && res.childCount > 0),
  };
};
